<project-templates [templates]="templates$ | async"
                   [loadingState]="templatesState$ | async"
                   [initialTemplateCode]="initialTemplateCode">
</project-templates>
